import React from 'react';
import Stack from '../Stack';
import { colors } from '../../../utils/theme';
import { getSpacing } from '../../../utils/spacing';
import { StyleProp, ViewStyle } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useIsMobileLayout } from '../../../hooks/useIsMobileLayout';

type HeaderStackOwnProps = {
    children: React.ReactNode;
    style?: StyleProp<ViewStyle>;
    noBorder?: boolean;
};

type HeaderStackProps = HeaderStackOwnProps;

export const HEADER_HEIGHT = 62;

const SharedContainer: React.FC<HeaderStackProps> = ({ children, style, noBorder }) => {
    const isMobile = useIsMobileLayout();
    const _insets = useSafeAreaInsets();
    return (
        <Stack
            horizontal
            style={[
                {
                    width: '100%',
                    height: HEADER_HEIGHT,
                    backgroundColor: isMobile ? 'white' : undefined,
                    borderBottomWidth: 1,
                    borderBottomColor: colors.Dividers,
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: getSpacing(8),
                    paddingRight: getSpacing(8),
                    // paddingTop: insets.top,
                    ...(noBorder && { borderBottomWidth: 0 }),
                },
                style,
            ]}
        >
            {children}
        </Stack>
    );
};

export default React.memo(SharedContainer);
